export const DELETE_SUCCESS = 'Группа удалена';
export const DELETE_ERROR = 'Не удалось удалить группу';
